let _config = {};

export async function loadConfig() {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) _config = await res.json();
  } catch {
    // Local dev: config.json doesn't exist — fall through to env vars
  }
}

// Synchronous getter — safe after loadConfig() resolves.
// config.json values take precedence; falls back to Vite env vars for local dev.
export function getConfig(key) {
  return _config[key] ?? import.meta.env[`REACT_APP_${key}`] ?? import.meta.env[key] ?? '';
}
